// ================================================
//	多言語切り替え（JA / EN / CN / TW）
//	URL パラメータ `?lang=ja|en|cn|tw` で切り替える。既定は ja
//	HTML 側の `data-i18n="キー"` の要素を辞書で差し替える
//	文言の置き場:
//	  日本語        … index.html（data-i18n の要素の中身がそのまま使われる）
//	  EN / CN / TW … assets/js/lang.js（ビルド不要・直接編集できる）
//	原稿の正本: 資料/2027SSコンセプト多国語.xlsx（2026-08-26 原田さん支給）
// ================================================

const LANGS = ['ja', 'en', 'cn', 'tw'];
const DEFAULT_LANG = 'ja';

const HTML_LANG = {
	ja: 'ja',
	en: 'en',
	cn: 'zh-Hans',
	tw: 'zh-Hant',
};

// EN / CN / TW の文言は assets/js/lang.js（ビルド不要・直接編集可）から読む。
// 日本語は index.html に書いたものを initLang() で取り込む
const EXTERNAL = (typeof window !== 'undefined' && window.HARE_LANG) || {};

const DICT = {
	ja: {},
	en: EXTERNAL.en || {},
	cn: EXTERNAL.cn || {},
	tw: EXTERNAL.tw || {},
};

export const getLang = () => {
	const param = new URLSearchParams(window.location.search).get('lang');
	const lang = (param || '').toLowerCase();
	return LANGS.includes(lang) ? lang : DEFAULT_LANG;
};

// 辞書を当てる本体。ページ遷移せずに何度でも呼べる
const applyLang = (lang) => {
	const dict = DICT[lang] || DICT[DEFAULT_LANG];

	document.documentElement.setAttribute('lang', HTML_LANG[lang] || HTML_LANG[DEFAULT_LANG]);
	document.documentElement.setAttribute('data-lang', lang);

	document.querySelectorAll('[data-i18n]').forEach((el) => {
		const key = el.dataset.i18n;
		if (dict[key] === undefined) return;
		el.innerHTML = dict[key];
	});

	// メニューの表示（現在の言語）と選択状態
	const current = document.querySelector('[data-lang-current]');
	if (current) current.textContent = lang.toUpperCase();

	// 現在の言語はボタン側に出ているので、リストからは隠す（重複させない）
	document.querySelectorAll('.menu__link').forEach((link) => {
		const isCurrent = link.dataset.lang === lang;
		link.classList.toggle('is-current', isCurrent);
		const li = link.closest('li');
		if (li) li.hidden = isCurrent;
	});
};

// その場で切り替える（ページを再読み込みしないのでスクロール位置が動かない）
export const setLang = (lang) => {
	if (!LANGS.includes(lang) || lang === getLang()) return;
	const url = new URL(window.location.href);
	url.searchParams.set('lang', lang);
	window.history.pushState({ lang }, '', url);
	applyLang(lang);
};

export const initLang = () => {
	// 日本語は HTML に書いてあるものを正とする（改行を index.html で直せるように）。
	// DICT.ja は EN/CN/TW から戻ってきた時に使うので、初回に HTML の中身で上書きしておく
	document.querySelectorAll('[data-i18n]').forEach((el) => {
		DICT.ja[el.dataset.i18n] = el.innerHTML;
	});

	applyLang(getLang());
	// 戻る/進むでも切り替わるようにする
	window.addEventListener('popstate', () => applyLang(getLang()));
};
